import React from 'react'
import './offering.css'
import SubHeading from '../../../subHeading/SubHeading'

const Offering = () => {
    return (
        <section className='offering'>
            <div className='offering__container'>
                <div className='offering__header'>
                    <SubHeading title='Cultura Menstrual' color={true} />
                </div>

                <div className='offering__definition-box'>
                    <p className='offering__intro'>
                        Según la UNESCO, la cultura es <span className='offering__highlight'>"el conjunto de los rasgos distintivos, espirituales, materiales, intelectuales y afectivos que caracterizan a una sociedad o grupo social"</span>. Engloba las artes, las letras, los modos de vida, los derechos fundamentales, los sistemas de valores, tradiciones y creencias.
                    </p>

                    <div className='offering__content'>
                        <p className='offering__text'>
                            El <strong>concepto de Cultura Menstrual</strong> se propone como un <strong>campo de análisis sociocultural y político</strong> que revisa, cuestiona y transforma los conocimientos, creencias, prácticas y representaciones en torno a la anatomía, fisiología, menstruación, ciclo ovárico-menstrual, fertilidad y climaterio.
                        </p>

                        <p className='offering__text'>
                            <strong>Nombrar 'cultura'</strong> a este campo implica reconocer que los procesos fisiológicos de las niñas, mujeres y personas menstruantes no constituyen hechos exclusivamente biológicos, sino <strong>experiencias profundamente atravesadas por condiciones sociales, económicas, ambientales y simbólicas</strong> que inciden en la salud sexual y reproductiva.
                        </p>

                        <p className='offering__text'>
                            Por ello, la <strong>cultura menstrual no puede pensarse como una experiencia homogénea ni universal</strong>. Las vivencias menstruales están moduladas por múltiples dimensiones: desigualdades de clase, acceso a salud, edad, identidad de género, racismo estructural, religiones, discapacidades, exposición a contaminantes ambientales, territorio, contextos de institucionalización, ámbito laboral, migraciones, guerras y catástrofes naturales, entre otras.
                        </p>

                        <p className='offering__text'>
                            La <strong>Cultura Menstrual contemporánea</strong> no solo visibiliza las experiencias menstruales, sino que se constituye como una <strong>práctica política y colectiva de resistencia</strong> frente al reduccionismo biológico, la sobremedicalización, la estandarización y la estigmatización. <strong>Reconocer la diversidad de vivencias</strong> impulsa la autonomía, el saber y el poder de las niñas, mujeres y personas menstruantes, promoviendo una transformación social hacia la equidad y el respeto.
                        </p>

                        <p className='offering__credit'>
                            <em>Conceptualización elaborada por Carolina Ackermann Barreiro, cofundadora de la Asociación de cultura menstrual, La Vida en Rojo.</em>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Offering